import { ChangeDetectionStrategy, Component, OnChanges } from '@angular/core';
import { NgClass } from '@angular/common';

import { GenericStatusEnumExtensions } from '~app/models/enums/generic-status.enum';
import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { GenericStatusColumnModel } from '~components/dynamic-table/models/column-types/generic-status-column.model';
import { Identifyable } from '~core/abstractions/identifyable';

@Component({
    selector: 'arc-generic-status-column',
    templateUrl: './generic-status-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [NgClass]
})
export class GenericStatusColumnComponent<T extends Identifyable<TId>, TId = number>
    extends BaseColumnComponent<T, TId>
    implements OnChanges
{
    get castedColumnModel(): GenericStatusColumnModel {
        return this.columnModel as GenericStatusColumnModel;
    }

    descriptionColumn!: string;
    bgColor!: string;

    ngOnChanges(): void {
        const statusValue = this.getItemValue(this.castedColumnModel.statusColumn);
        this.descriptionColumn = this.castedColumnModel.descriptionFn
            ? this.castedColumnModel.descriptionFn(statusValue)
            : this.getItemValue(this.castedColumnModel.descriptionColumn);
        this.bgColor = !!this.castedColumnModel.bgColor
            ? this.castedColumnModel.bgColor(statusValue)
            : GenericStatusEnumExtensions.getColor(statusValue);
    }
}
